var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 77,
    viewBox: "0 0 375 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-111.758 40.9102L-55.7013 55.2132C-53.4879 55.7779 -52.3812 56.0603 -51.2511 56.0603C-50.121 56.0603 -49.0144 55.7779 -46.801 55.2132L2.0306 42.7537C5.59543 41.8441 7.37784 41.3893 9.14993 41.6443C10.922 41.8993 12.5039 42.8381 15.6677 44.7159L58.9338 70.3946C64.1689 73.5016 66.7864 75.0551 69.614 74.8433C72.4416 74.6314 74.7984 72.7051 79.5119 68.8525L123.887 32.5831C127.349 29.7535 129.08 28.3387 131.179 27.8772C133.278 27.4156 135.442 27.9738 139.772 29.09L187.396 41.3683C189.748 41.9747 190.924 42.2779 192.124 42.2626C193.323 42.2472 194.491 41.9141 196.827 41.2479L248.817 26.418C251.051 25.7806 252.169 25.4618 253.318 25.4344C254.466 25.407 255.598 25.672 257.86 26.202L306.088 37.5006C309.733 38.3545 311.556 38.7815 313.35 38.4754C315.144 38.1693 316.722 37.1621 319.878 35.1478L375 -0.0351562",
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphMobile);
export default __webpack_public_path__ + "static/media/GraphMobile.fcddbd3b.svg";
export { ForwardRef as ReactComponent };